import TimelineMax from 'TimelineMax'
import { select } from "@assets/scripts/utils";

export default function () {
    let svg = select('.i4')[0]
    if(!svg) return
    svg = svg.contentDocument

    const platform = svg.querySelector('.platform')
    const platformTl = new TimelineMax()
    platformTl
        .fromTo(platform, 1, { y: -5 }, { y: 10, ease: SteppedEase.config(3) })
        .to(platform, 1, { y: -5, ease: SteppedEase.config(3) })
        .repeat(-1)

    const lights = select('.lights path', svg)
    const tll = new TimelineMax
    const lightsArray = [
        [8,9,0],
        [1,3,7],
        [2,4,5,9],
        [3,8,10],
        [1,2,6],
        [2,3,8],
        [0,7,10]
    ]
        .map(item => item.map(i => lights[i]))

    tll
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[0], { autoAlpha: 1 })
        })
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[1], { autoAlpha: 1 })
        }, 0.35)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[2], { autoAlpha: 1 })
        }, 0.7)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[3], { autoAlpha: 1 })
        }, 1.15)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[4], { autoAlpha: 1 })
        }, 1.5)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[5], { autoAlpha: 1 })
        }, 1.85)

    tll.repeat(-1)


    const charts = svg.querySelector('.charts')
    const chart1 = svg.querySelector('.chart1')
    const chart2 = svg.querySelector('.chart2')
    const string1mask = svg.querySelector('.string1mask')

    const charttl = new TimelineMax()

    charttl
        .add(() => {
            TweenMax.fromTo(charts, 1, { x: '0%' }, { x: '20%', ease: SteppedEase.config(3) })
            TweenMax.fromTo(chart1, 1, { width: 10 }, { width: 20, ease: SteppedEase.config(3) })
            TweenMax.fromTo(chart2, 1, { width: 16 }, { width: 8, ease: SteppedEase.config(3) })
            TweenMax.fromTo(string1mask, 2, { y: '-61%' }, { y: '0%', ease: SteppedEase.config(2) })
        })
        .add(() => {
            TweenMax.to(charts, 1, { x: '0%', ease: SteppedEase.config(3) })
            TweenMax.to(chart1, 1, { width: 10, ease: SteppedEase.config(3) })
            TweenMax.to(chart2, 1, { width: 16, ease: SteppedEase.config(3) })
        }, 1)
        .repeatDelay(1)
        .repeat(-1)

    const ticks = select('.ticks path', svg)
    const ticktl = new TimelineMax()
    const ticksMap = [
        [0, 4],
        [3],
        [0, 2, 3],
        [1, 4],
        [2],
    ].map(item => item.map(i => ticks[i]))

    ticktl
        .add(() => {
            TweenMax.set(ticks,{ autoAlpha: 0 })
            TweenMax.set(ticksMap[0], { autoAlpha: 1 })
        })
        .add(() => {
            TweenMax.set(ticks,{ autoAlpha: 0 })
            TweenMax.set(ticksMap[1], { autoAlpha: 1 })
        }, 0.3)
        .add(() => {
            TweenMax.set(ticks,{ autoAlpha: 0 })
            TweenMax.set(ticksMap[2], { autoAlpha: 1 })
        }, 0.6)
        .add(() => {
            TweenMax.set(ticks,{ autoAlpha: 0 })
            TweenMax.set(ticksMap[3], { autoAlpha: 1 })
        }, 0.9)
        .add(() => {
            TweenMax.set(ticks,{ autoAlpha: 0 })
            TweenMax.set(ticksMap[4], { autoAlpha: 1 })
        }, 1.2)
        .repeatDelay(0.3)
        .repeat(-1)
}
